export const DefectsActions = {
  GET_DEFECTS_LIST: "GET_DEFECTS_LIST",
  SET_DEFECTS_LIST: "SET_DEFECTS_LIST",

  GET_DEFECTS_DETAILS_LIST: "GET_DEFECTS_DETAILS_LIST",
  SET_DEFECTS_DETAILS_LIST: "SET_DEFECTS_DETAILS_LIST",
  UPDATE_DEFECTS_DETAILS_LIST: "UPDATE_DEFECTS_DETAILS_LIST",
  IS_UPDATE_SUCCESS_DEFECTS_DETAILS: "IS_UPDATE_SUCCESS_DEFECTS_DETAILS",
  SET_DEFECTS_PAGINATION_LIST: "SET_DEFECTS_PAGINATION_LIST",
  // define other action types here
};
